module.exports = __webpack_public_path__ + "img/Dantam Fashion 01.fd272a1c.jpg";